import { baseFetch } from "./baseFetch";
import { REPORTING_MONTHLY_USAGE } from "./urls";

type FetchMonthlyUsage = {
  (
    token: string,
    body: {
      timezone: string;
      start_date: string;
      end_date: string;
    }
  ): Promise<unknown>;
};
export const fetchMonthlyUsage: FetchMonthlyUsage = (token: string, body) =>
  baseFetch(`${REPORTING_MONTHLY_USAGE}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
